export const H7_COMPARISON_ARTICLE = {
  datePublished: '2025-10-22',
  dateModified: '2026-11-04',
}

export const PEUGEOT_2008_LOW_BEAM_ARTICLE = {
  datePublished: '2025-08-11',
  dateModified: '2026-06-11',
}

export const LIGHTING_CHECK_GUIDE = {
  datePublished: '2026-10-14',
  dateModified: '2026-10-14',
}

export const STATIC_ARTICLE_DATES = {
  'blog-led-accessoires-vehicules/verifier-eclairage-voiture':
    LIGHTING_CHECK_GUIDE,
  'blog-led-accessoires-vehicules/comparatif-meilleures-ampoules-led-h7':
    H7_COMPARISON_ARTICLE,
  'blog-led-accessoires-vehicules/meilleures-ampoules-feux-de-croisement-peugeot-2008':
    PEUGEOT_2008_LOW_BEAM_ARTICLE,
}
